import { useTheme } from '../../redux/hooks/useTheme';
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import CircularLoading from '../utils/HelperComponents/CircularLoading'
interface Loader {
    text: string;
    isLoading: boolean;
    imageUrl?: string;// Optional imageUrl prop
}

const Loader: React.FC<Loader> = ({ text, isLoading,imageUrl }) => {
    const { theme } = useTheme();
    const [progress, setProgress] = useState(0);
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    useEffect(() => {
    if (isLoading) {
        setProgress(0); // Reset on every load
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + 1;
            });
        }, 1);

        return () => clearInterval(interval);
    }
}, [isLoading]);

    

    if (!isLoading) return null
    return (    
        <div className="absolute flex flex-col items-center justify-center w-full h-full z-100 opacity-1 visible transition-all duration-300 top-0 left-0" 
        style={{color: theme.color}}>
         {isHomePage ? (
          <div
          className='mbrs-loader'
    style={{
    width: '400px',
    height: '30px',
    backgroundColor: '#edeff2',
    borderRadius: '999px',
    overflow: 'hidden'
  }}
>
  <div
  className='mbrs-mini'
    style={{
      height: '100%',
      width: `${progress}%`,
      backgroundColor: '#e07167',
      borderRadius: '999px',
      transition: 'all 0.1s ease-in-out'
    }}
  ></div>
</div>
          ) : (  
            <div className="flex flex-col items-center justify-center">
            {imageUrl && text && (
                      <>
                          <img src={imageUrl} alt="Loading..." className="w-100 h-100" />
                          <p className="mt-2 text-center text-gray-700">{text}</p>
                      </>
                  )}
  
                 {imageUrl && !text && (
                      <img src={imageUrl} alt="Loading..." className="w-100 h-100" />
                  )}
                   {!imageUrl && text && <p className="mt-2 text-center text-gray-700">{text}</p>} 
              {/* {imageUrl ? (
               <img src={imageUrl} alt="Loading..." className="w-100 h-100" />
                 ) : (
                  imageUrl || text && <p className="mt-2 text-gray-700">{text}</p>
                 
               )} */}
               {/* {imageUrl && text && <p className="mt-2 text-gray-700">{text}</p>} */}
               {/* {imageUrl || text && <p className="mt-2 text-gray-700">{text}</p>} */}
               {/* <CircularLoading text={text} secondary={theme.primary} /> */}
              </div>
          
             )}  
        </div>
    )
}

export default Loader
